module.exports = "/images/DF.png?f6220beb27de5785a43f5e6037452e4c";